import {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import {AuthLayoutFooter} from './auth-layout-footer';
import './rekaweb-auth.css';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}
export function AuthLayout({heading, children, message}: AuthPageProps) {
  return (
    <main className="rekaweb-auth">
      <aside className="rekaweb-auth-brand" aria-label="Rekaweb">
        <Link className="rekaweb-auth-logo" to="/" aria-label="Rekaweb, halaman utama">
          <img src="/images/rekaweb-logo-white.png" alt="Rekaweb" width="2168" height="725" />
        </Link>
        <div className="rekaweb-auth-story">
          <span className="rekaweb-auth-eyebrow">WEBSITE UNTUK PERNIAGAAN ANDA</span>
          <h2>Idea anda.<br />Website anda.</h2>
          <p>Pilih template, sesuaikan keperluan dan urus tempahan website anda dalam satu tempat.</p>
          <ol>
            <li><span>01</span>Pilih reka bentuk pilihan anda</li>
            <li><span>02</span>Sesuaikan pakej website</li>
            <li><span>03</span>Pantau perkembangan tempahan</li>
          </ol>
        </div>
        <a className="rekaweb-auth-brand-link" href="https://rekaweb.my/">Rekaweb.my ↗</a>
      </aside>
      <div className="rekaweb-auth-main">
        <Link className="rekaweb-auth-back" to="/">← Kembali ke template</Link>
        <div className="rekaweb-auth-card">
          <span className="rekaweb-auth-eyebrow">AKAUN REKAWEB</span>
          {heading && <h1>{heading}</h1>}
          <p className="rekaweb-auth-intro">Urus tempahan dan maklumat website anda dengan mudah.</p>
          {children}
          {message && <div className="rekaweb-auth-switch">{message}</div>}
        </div>
        <footer className="rekaweb-auth-footer"><AuthLayoutFooter /></footer>
      </div>
    </main>
  );
}
